import React from 'react'
import PropTypes from 'prop-types'

const Close = ({ className }) => (
  <svg className={ className }width="16" height="15" viewBox="0 0 16 15" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M2.36572 1.47705L13.7949 12.9062" stroke="#999999" strokeWidth="2" strokeMiterlimit="10" strokeLinecap="round"/>
    <path d="M13.7944 1.47705L2.36529 12.9062" stroke="#999999" strokeWidth="2" strokeMiterlimit="10" strokeLinecap="round"/>
  </svg>

)

Close.propTypes = {
  className: PropTypes.string,
}

export default Close

